export const DELIVERY_TYPE = {
  // 自提
  PICK: "73",
  // 快递运输
  EXPRESS_DELIVERY: "66",
};

// 用于判断是立减、商品金额楼层、小结金额、促销小计
export const AMOUNT_FLOOR_TYPE = {
  PRODUCT_AMOUNT: "0", // 商品金额
  PROMOTIONS: "1", // 纯促销金额，不包含券/码金额
  TOTAL: "2", // 应付金额
  SUB_TOTAL: "3", // 小结金额
  PROMOTION_SUB_TOTAL: "4", // 促销小计, 包含券/码金额；暂不使用
  COUPONS: "5", // 优惠券/码金额
  DISCOUNT: "6", // 特优惠
};

// 用于判断商品是否无货
export const STOCK_STATUS_CODE = {
  IN_STOCK: "33",
  OUT_STOCK: "34",
};

// 最近门店标志
export const DSITANCE_TYPE = {
  MIN: "1",
};

export const SUBMIT_CODE_TYPE = {
  ALL_OUT_STOCK: "VCYBB2C-DM@1013-CD@2.500101",
  PART_OUT_STOCK: "VCYBB2C-DM@1013-CD@2.500102",
  STOCK_ERROR: ["VCYBB2C-DM@1013-CD@2.200002", "VCYBB2C-DM@1013-CD@2.500100"],
};

export const IMAGE_DOMAIN = "${KA_BASE_WX_STATIC_DOMAIN}";

// 数据请求成功
export const RESULT_CODE = "C-DM@60-CD@1.100000";
// 阿波罗接口请求成功
export const API_CODE = "0";

// 结算页的操作枚举
export const ACTION_TYPE = {
  ADDRESS: "address", // 地址操作
  CART: "cart", // 购物车操作
  COUPON: "coupon", // 优惠券操作
  CODE: "code", // 优惠码操作
  SAVECOUPON: "saveCoupon",
};

// 结算页的接口调用操作枚举
export const ALL_ACTION_TYPE = {
  INIT: "init", // 初始化
  CHANGE_ADDRESS: "changeAddress", // 修改地址
  COUPON: "coupon", // 优惠券操作
  CODE: "code", // 优惠码操作
  CART: "cart", // 购物车操作
  SAVECOUPON: "saveCoupon",
  CHANGE_PAYMENT: "changePayment", // 修改支付方式
};

// 支付方式枚举
export const PAY_TYPE = {
  // apple pay
  APPLE: 8,
  // paypal
  PAYPAL: 15,
  // 信用卡
  CREDIT_CARD: 16,
  // google pay
  GOOGLE_PAY: 17,
  // wechat pay
  WECHAT_PAY: 18,
  // 分期Klarna
  KLARNA: 19,
};

// 支付网关
export const PAY_ENUM = {
  // paypal
  PAYPAL: "1004",
  // bnp
  BNP: "1007",
  // worldline
  WORLDLINE: "1008",
  // 分期Klarna
  KLARNA: "1010",
};

// 跳转方式

export const INTEGRATION_TYPE = {
  /**
   * 使用三方收银台， 回跳转到三方页码
   *   默认。 简单、安全
   */
  HOSTED_CHECKOUT: "HOSTED_CHECKOUT",
  /**
   * 直接发起支付.
   * 包含快捷支付、定期支付等， 需要更严格的PCI认证
   */
  PAYMENT: "PAYMENT",
};

// 4-VISA 5-MasterCard && Maestro
export const BNP_BANK_TYPE = {
  VISA: "4",
  MASTER_CARD: "5",
};

export const BNP_BANK_STR = {
  VISA: "VISA",
  MASTER_CARD: "MasterCard",
  DEFAULT: "default",
};

export const USER_ACTION_ID = {
  // 改变数量
  CHANGE_NUM: "changeNum",
  // 反选
  UN_SELECT: "unselect",
};

export const uniformBizInfo = {
  tenantId: 1,
  buId: 405,
  channelId: 0,
  ua: 4,
};

export const PAY_STATUS = {
  INIT: 1,
  PROCESS: 2,
  SUCCESS: 3,
  ERROR: 4,
};

export const RESULT_STR = {
  SUCCESS: "success",
  ERROR: "error",
  CONTINUE: "continue",
};
// 微信支付状态
export enum WechatPaymentStatus {
  /** 支付完成 */
  PAID = "paid",
  /** 授权成功 */
  AUTHORIZED = "authorized",
  /** 支付被创建 */
  PENDING = "pending",
  /** 等待支付 */
  PROCESSING = "processing",
  /** 客户已经支付，由于风控原因正在审核中。 */
  VERIFY = "verify",
  /** 支付被拒绝 */
  DECLINED = "declined",
  /** 支付失败 */
  FAILED = "failed",
  /** 支付超时 */
  EXPIRED = "expired",
  /** 取消支付 */
  CANCELLED = "cancelled",
}


export const CHECKOUT_PAYMENT_TRACK_MAP = {
  "productAmount": "itemTotal",
  "promotionsTotal": "totalDiscount",
  "subTotal": "subTotal",
  "freightAmount": "freightfee",
  "promotions": "promotions",
  "discount": "discount",
}
